
import Vue from 'vue';
import { BlockCollection } from '@headlines/components/block';
import CustomerDataHeadline from '@root/modules/customer/components/CustomerDataHeadline.vue';
import { QueryResult, HeadlineSettings, Data as HeadlinesData } from '@root/modules/headlines/types/headlines';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';

const Pagination = () => import(/* webpackChunkName: "HeadlineList/Pagination" */ '@root/common/components/base/pagination/Pagination.vue');

interface Props {
  type: string;
  list: QueryResult;
  settings: HeadlineSettings;
  pagination?: boolean;
  insertBannerAfterItems?: number;
  pager?: {
    offset: number;
    limit: number;
    count: number;
  };
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  components: {
    BlockType4: BlockCollection.BlockType4,
    BlockType101: BlockCollection.BlockType101,
    BlockType102: BlockCollection.BlockType102,
    CustomerDataHeadline,
    Pagination,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    list: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
    pagination: {
      type: Boolean,
      default: false,
      required: false,
    },
    pager: {
      type: Object,
      required: false,
    },
    insertBannerAfterItems: {
      type: Number,
      default: 5,
      required: false,
    },
  },
  computed: {
    data() {
      const data = Object.assign({}, this.list);

      if (data.items.length) {
        const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
        const headlinesWithHref = data.items.map((headline: HeadlinesData) => {
          const { domain } = this.$channelConfig('settings');
          return getHeadlineWithHref({ headline, domain, fakeDomainEnabled });
        });

        data.items = headlinesWithHref;
      }

      return data;
    },
  },
});
